import type { SdkWorkspaceValues } from './types';

export type WorkspaceValuesStore = {
  getSnapshot(): SdkWorkspaceValues;
  subscribe(listener: () => void): () => void;
  /** Merge saved values into the snapshot and notify subscribers. */
  set(values: SdkWorkspaceValues): void;
};

/**
 * Holds the workspace field values a page reads through `Sdk.hooks.useWorkspaceValues`.
 * Seeded once from the page payload; only a successful `WorkspaceFieldsForm` save
 * writes it. Nothing refreshes it from the server.
 */
export function createWorkspaceValuesStore(
  initial: SdkWorkspaceValues | null | undefined
): WorkspaceValuesStore {
  let snapshot: SdkWorkspaceValues = { ...initial };
  const listeners = new Set<() => void>();

  return {
    getSnapshot: () => snapshot,
    subscribe: (listener) => {
      listeners.add(listener);

      return () => {
        listeners.delete(listener);
      };
    },
    set: (values) => {
      snapshot = { ...snapshot, ...values };

      for (const listener of listeners) {
        listener();
      }
    }
  };
}
